const _page = {
    $document: $(document),
    $window: $(window),
    $body: $(document.body),
    $htmlBody: $('html,body'),
    $html: $('html'),
    breakpointElement: document.querySelector('body'),
    breakpointsArray: ['mobile', 'tablet', 'laptop', 'desktop', 'widescreen'],
    breakpoint: {
        current: null,
        currentIndex: null,
        alternate: null,
        order: []
    }
};

export default _page;
